__turbopack_context__.v({
  "description": "sectionHeader-module-scss-module__TDprCq__description",
  "title": "sectionHeader-module-scss-module__TDprCq__title",
  "wrapper": "sectionHeader-module-scss-module__TDprCq__wrapper",
});
